module.exports = __webpack_public_path__ + "img/3L1A8710.7c59525f.jpg";